import { createContext } from 'react';

/**
 * Whether the signed-in account may see the operational dashboard.
 *
 * Its own context rather than a permission bit, because access is a per-account
 * grant an admin hands out — `filterNavItems` only understands bitmasks, so a
 * grant-based nav item cannot go through it.
 */
export const OperationalDashboardAccessContext = createContext({
    hasAccess: false,
    loading: false,
});

export default OperationalDashboardAccessContext;
